var map = {
	"./2020/report-1.jpg": "ce9b",
	"./2020/report-10.jpg": "616d",
	"./2020/report-2.jpg": "0c52",
	"./2020/report-3.jpg": "aff7",
	"./2020/report-4.jpg": "0c32",
	"./2020/report-5.jpg": "ecdb",
	"./2020/report-6.jpg": "72e8",
	"./2020/report-7.jpg": "050c",
	"./2020/report-8.jpg": "0e94",
	"./2020/report-9.jpg": "0d10",
	"./2021/report-1.jpg": "30c0",
	"./2021/report-10.jpg": "4e94",
	"./2021/report-2.jpg": "bbc2",
	"./2021/report-3.jpg": "638e",
	"./2021/report-4.jpg": "264f",
	"./2021/report-5.jpg": "2aba",
	"./2021/report-6.jpg": "cb1b",
	"./2021/report-7.jpg": "311b",
	"./2021/report-8.jpg": "d6b7",
	"./2021/report-9.jpg": "b558"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b68";